import { Avatar, styled } from "@cirrus/ui-kit"
import T from "prop-types"
import { createElement as h } from "react"
import { useSelector } from "react-redux"

import { CurrentUserModel } from "../model/index.js"

const StyledAvatar = styled(Avatar)({ marginRight: 10 })

export const AvatarIcon = ({ className }) =>
  h(StyledAvatar, {
    alt: "User avatar",
    className,
    src: useSelector(CurrentUserModel.state.avatar),
  })

AvatarIcon.propTypes = {
  className: T.string,
}
